export class TravelSimRegistrationToken {
  static ITravelSimRegistrationRepository = Symbol(
    "ITravelSimRegistrationRepository",
  );
  static TravelSimRegistrationViewModel = Symbol(
    "TravelSimRegistrationViewModel",
  );
  static OutboundRegistrationViewModel = Symbol("OutboundRegistrationViewModel");
  static TravelSimRegistrationUseCase = Symbol("TravelSimRegistrationUseCase");
}
